import { useQuery } from 'react-query';

import { TRIAL_SIGNUP_QUERY_KEYS } from '../../constants';
import {
  fetchTrialCountries,
  type TrialCountryOption,
} from '../../request';

export const useGetTrialCountries = () =>
  useQuery<TrialCountryOption[], Error>(
    [TRIAL_SIGNUP_QUERY_KEYS.COUNTRIES],
    ({ signal }) => fetchTrialCountries(signal),
    { staleTime: Infinity }
  );
